import { Result } from '@/main/models/common/resultResponse';
import { AxiosResponse } from 'axios';
import { api, ICacheApi } from '../base';

const baseRoute: string = 'Cache';

export class CacheApi extends ICacheApi {
  get(key: string): Promise<AxiosResponse<Result<string>>> {
    return api.get(`${baseRoute}`, { params: { key } });
  }
  save(
    key: string,
    serializedData: string
  ): Promise<AxiosResponse<Result<string>>> {
    return api.post(`${baseRoute}`, { key, serializedData });
  }
}

